import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Signal, Position } from '../types/types';

const Portfoy: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'SIGNALS' | 'ACTIVE' | 'HISTORY'>('SIGNALS');

  // Örnek veriler (backend'den gelecek)
  const signals: Signal[] = [
    {
      id: '1',
      coin: 'BTC',
      type: 'LONG',
      entryPrice: 42000,
      targetPrice: 45000,
      stopLoss: 41000,
      timestamp: new Date(),
      status: 'ACTIVE',
      message: 'BTC/USDT için LONG sinyali! RSI ve MACD indikatörleri güçlü alım fırsatı gösteriyor.',
    },
    {
      id: '2',
      coin: 'ETH',
      type: 'SHORT',
      entryPrice: 2800,
      targetPrice: 2600,
      stopLoss: 2900,
      timestamp: new Date(),
      status: 'PENDING',
      message: 'ETH/USDT için SHORT sinyali! Fiyat direnç noktasından reddedildi.',
    }
  ];

  const activePositions: Position[] = [
    {
      id: '1',
      signalId: '1',
      type: 'LONG',
      coin: 'BTC',
      entryPrice: 42000,
      targetPrice: 45000,
      stopLoss: 41000,
      currentPrice: 43500,
      amount: 0.5,
      pnl: 750,
      pnlPercentage: 3.57,
      openDate: new Date(),
      status: 'ACTIVE',
      signal: signals[0]
    }
  ];

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={() => navigate('/dashboard')}>
            <BackIcon>←</BackIcon>
            <span>Ana Sayfa</span>
          </BackButton>
          <Title>Sinyal ve Pozisyon Takibi</Title>
        </HeaderLeft>
      </Header>

      <TabContainer>
        <TabButton 
          $isActive={activeTab === 'SIGNALS'} 
          onClick={() => setActiveTab('SIGNALS')}
        >
          <TabIcon>🔔</TabIcon>
          Sinyaller
        </TabButton>
        <TabButton 
          $isActive={activeTab === 'ACTIVE'} 
          onClick={() => setActiveTab('ACTIVE')}
        >
          <TabIcon>📊</TabIcon>
          Aktif Pozisyonlar
        </TabButton>
        <TabButton 
          $isActive={activeTab === 'HISTORY'} 
          onClick={() => setActiveTab('HISTORY')}
        >
          <TabIcon>📜</TabIcon>
          Geçmiş
        </TabButton>
      </TabContainer>

      {activeTab === 'SIGNALS' && (
        <SignalsContainer>
          {signals.map(signal => (
            <SignalCard key={signal.id} $type={signal.type}>
              <SignalHeader>
                <SignalType $type={signal.type}>
                  {signal.type === 'LONG' ? '📈 LONG' : '📉 SHORT'}
                </SignalType>
                <SignalTime>
                  {signal.timestamp.toLocaleTimeString()}
                </SignalTime>
              </SignalHeader>
              
              <SignalCoin>{signal.coin}/USDT</SignalCoin>
              <SignalMessage>{signal.message}</SignalMessage>
              
              <SignalDetails>
                <DetailItem>
                  <DetailLabel>Giriş</DetailLabel>
                  <DetailValue>${signal.entryPrice}</DetailValue>
                </DetailItem>
                <DetailItem>
                  <DetailLabel>Hedef</DetailLabel>
                  <DetailValue>${signal.targetPrice}</DetailValue>
                </DetailItem>
                <DetailItem>
                  <DetailLabel>Stop</DetailLabel>
                  <DetailValue>${signal.stopLoss}</DetailValue>
                </DetailItem>
              </SignalDetails>

              <SignalStatus $status={signal.status}>
                {signal.status === 'PENDING' ? 'Beklemede' : 
                 signal.status === 'ACTIVE' ? 'Aktif' :
                 signal.status === 'COMPLETED' ? 'Tamamlandı' : 'Başarısız'}
              </SignalStatus>
            </SignalCard>
          ))}
        </SignalsContainer>
      )}

      {activeTab === 'ACTIVE' && (
        <PositionsContainer>
          {/* Aktif pozisyonlar tablosu buraya gelecek */}
        </PositionsContainer>
      )}

      {activeTab === 'HISTORY' && (
        <HistoryContainer>
          {/* Geçmiş pozisyonlar tablosu buraya gelecek */}
        </HistoryContainer>
      )}
    </Container>
  );
};



const Container = styled.div`
  padding: 32px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: #0f172a;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  background: rgba(30, 41, 59, 0.5);
  padding: 20px;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #60A5FA;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(96, 165, 250, 0.1);
    transform: translateX(-2px);
  }
`;

const BackIcon = styled.span`
  font-size: 1.2rem;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  color: #F1F5F9;
  margin: 0;
  font-weight: 600;
`;

const TabContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
  background: rgba(30, 41, 59, 0.5);
  padding: 8px;
  border-radius: 12px;
`;

const TabButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${props => props.$isActive ? 'rgba(59, 130, 246, 0.1)' : 'transparent'};
  border: none;
  color: ${props => props.$isActive ? '#60A5FA' : '#94A3B8'};
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  flex: 1;
  justify-content: center;

  &:hover {
    background: rgba(59, 130, 246, 0.1);
  }
`;

const TabIcon = styled.span`
  font-size: 1.2rem;
`;

const SignalsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
`;

const SignalCard = styled.div<{ $type: 'LONG' | 'SHORT' }>`
  background: rgba(30, 41, 59, 0.5);
  border-radius: 16px;
  padding: 24px;
  border: 1px solid ${props => props.$type === 'LONG' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'};
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: ${props => props.$type === 'LONG' ? 'rgba(16, 185, 129, 0.4)' : 'rgba(239, 68, 68, 0.4)'};
    box-shadow: 0 4px 20px rgba(15, 23, 42, 0.3);
  }
`;

const SignalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const SignalType = styled.div<{ $type: 'LONG' | 'SHORT' }>`
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  background: ${props => props.$type === 'LONG' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)'};
  color: ${props => props.$type === 'LONG' ? '#10B981' : '#EF4444'};
`;

const SignalTime = styled.div`
  color: #94A3B8;
  font-size: 0.9rem;
`;

const SignalCoin = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  color: #F1F5F9;
  margin-bottom: 12px;
`;

const SignalMessage = styled.div`
  color: #94A3B8;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 20px;
`;

const SignalDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px;
  background: rgba(15, 23, 42, 0.3);
  border-radius: 12px;
`;

const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DetailLabel = styled.div`
  color: #94A3B8;
  font-size: 0.8rem;
`;

const DetailValue = styled.div`
  color: #F1F5F9;
  font-weight: 500;
`;

const SignalStatus = styled.div<{ $status: Signal['status'] }>`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 500;
  background: ${props => {
    switch (props.$status) {
      case 'PENDING': return 'rgba(234, 179, 8, 0.1)';
      case 'ACTIVE': return 'rgba(59, 130, 246, 0.1)';
      case 'COMPLETED': return 'rgba(16, 185, 129, 0.1)';
      case 'FAILED': return 'rgba(239, 68, 68, 0.1)';
    }
  }};
  color: ${props => {
    switch (props.$status) {
      case 'PENDING': return '#EAB308';
      case 'ACTIVE': return '#3B82F6';
      case 'COMPLETED': return '#10B981';
      case 'FAILED': return '#EF4444';
    }
  }};
`;

const PositionsContainer = styled.div`
  // Aktif pozisyonlar için stil
`;

const HistoryContainer = styled.div`
  // Geçmiş pozisyonlar için stil
`;

export default Portfoy;